export class Invite {
	constructor({ email, roles, inviteLink } = {}) {
		this.email = email;
		this.roles = roles;
		this.inviteLink = inviteLink;
	}
}

export class Users {
	/* TODO: Refactor to be generic */
	static getUserType(userGroups) {
		if (userGroups.includes(this.TYPES.PROFESSIONAL)) {
			return this.TYPES.PROFESSIONAL;
		}
		if (userGroups.includes(this.TYPES.COMPANY)) {
			return this.TYPES.COMPANY;
		}
		if (userGroups.includes(this.TYPES.SUPER_ADMIN)) {
			return this.TYPES.SUPER_ADMIN;
		}
	}

	static get TYPES() {
		return USER_TYPES;
	}

	static get EMPLOYMENT_STATUS() {
		return EMPLOYMENT_STATUS;
	}

	static get EMPLOYMENT_STATUS_OPTIONS() {
		return Object.values(this.EMPLOYMENT_STATUS);
	}
}

export const USER_TYPES = {
	PROFESSIONAL: 'Locum',
	COMPANY: 'CompanyAdmin',
	SUPER_ADMIN: 'SuperAdmin',
};

export const EMPLOYMENT_STATUS = {
	FULL_TIME_EMPLOYED: {
		key: 'FULL_TIME_EMPLOYED',
		label: 'Full-time employed',
	},
	PART_TIME_EMPLOYED: {
		key: 'PART_TIME_EMPLOYED',
		label: 'Part-time employed',
	},
	UNEMPLOYED: {
		key: 'UNEMPLOYED',
		label: 'Unemployed',
	},
	STUDENT: {
		key: 'STUDENT',
		label: 'Student',
	},
	RETIRED: {
		key: 'RETIRED',
		label: 'Retired',
	},
};
